var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.5,19.7c-1.6-0.7-3.2-1.4-4.8-2.1c-10-4-23.9,3.5-27.9,11.6C7.4,36.1,8.5,44.6,14.1,50 c5.1,4.9,10.7,9.2,16.1,13.8c6.2,5.2,12.7,10.1,16.2,17.7c1.1,2.3,1.6,4.8,2.5,7.5c2.1-3.1,3.9-5.9,5.9-8.6c6-8.1,14.2-13.8,21.9-20 c5.4-4.3,10.6-8.7,13.4-15.3c6.2-14.8,0.5-31.4-16.2-36.4c-8.6-2.6-15.3,1-22.1,5c-1.2,0.7-2.3,1.6-3.6,2.2c4-5.3,9.1-8.9,15.5-10.9 C79.2,0.3,96.4,14.3,97,30.3c0.5,15.4-6.9,25.5-18.9,33.5c-9.7,6.5-19.3,13-26.1,22.8c-2,3-3.8,6.1-6.1,9.9c0-2.4,0.1-4,0-5.6 c-0.3-8.7-6-14-12.2-18.8c-7.4-5.7-15.3-10.9-22.4-16.9c-13-11.1-10.3-31,5-38.8c8.3-4.2,16.6-5.4,24.9,0c1.1,0.7,1.9,1.7,2.9,2.5 C43.9,19.2,43.7,19.4,43.5,19.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartWhite);
export default __webpack_public_path__ + "static/media/heart_white.a850940484995f124fb05d77784919f1.svg";
export { ForwardRef as ReactComponent };